import { isSSR } from "./ssr"

export const trackGoal = (name: string) => {
  const ym = (window as any).ym
  if (ym && !isSSR()) {
    ym(43576309, `reachGoal`, name)
  }
}
